import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type PillIconProps = Partial<SVGIconProps>;

const PillIcon: FC<PillIconProps> = (props) => (
  <SVGIcon viewBox="0 0 143 142" {...props}>
    <path
      d="M28.783 84.266l.262.261-.262-.261a21.04 21.04 0 0 0 .003 29.752 21.04 21.04 0 0 0 29.752-.003l25.011-25.011.261-.261-.262-.261-29.232-29.226-.261-.262-.261.262-25.011 25.011zm50.55-62.046l-.261-.261.261.261c5.471-5.471 12.891-8.544 20.628-8.544s15.157 3.074 20.628 8.544a29.2 29.2 0 0 1 .005 41.251l-56.302 56.292c-5.495 5.357-12.877 8.334-20.55 8.286a29.17 29.17 0 0 1-28.99-28.986c-.049-7.672 2.927-15.055 8.282-20.549L79.333 22.22zm35.505 35.5l.003-.003c3.87-3.961 6.021-9.287 5.989-14.824s-2.246-10.838-6.161-14.753a21.04 21.04 0 0 0-29.577-.173l-.003.003-25.016 25.011-.262.261.261.261 29.221 29.227.261.261.261-.261 25.022-25.011zm-9.081-11.793h0c.378.378.678.826.883 1.32a4.08 4.08 0 0 1 0 3.115c-.205.494-.505.942-.883 1.32h0L92.444 64.996a4.07 4.07 0 0 1-2.877 1.19 4.07 4.07 0 0 1-1.557-.31c-.493-.205-.942-.504-1.319-.882a4.07 4.07 0 0 1-.881-1.32c-.204-.494-.309-1.023-.309-1.557s.106-1.063.31-1.557a4.07 4.07 0 0 1 .882-1.319h0l13.313-13.312a4.07 4.07 0 0 1 5.751 0z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth=".74"
    />
  </SVGIcon>
);

export default PillIcon;
